import { stats } from '@/mocks/comics';

export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20anime%20cityscape%20at%20night%20with%20giant%20moon%20and%20neon%20glow%2C%20comic%20book%20art%20style%2C%20silhouettes%20of%20characters%20and%20floating%20manga%20pages%20in%20the%20sky%2C%20warm%20amber%20and%20golden%20accent%20lights%20against%20deep%20charcoal%20tones%2C%20dramatic%20atmosphere%2C%20high%20detail%20digital%20art&width=1600&height=1000&seq=hero-2026-x1&orientation=landscape"
          alt="香蕉漫画社首屏背景插画，夜晚霓虹都市与漫画元素"
          title="香蕉漫画社 - 人气漫画编辑推荐"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/60 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-28 text-center md:px-6">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-sm font-medium text-primary-300">
          <i className="ri-flashlight-fill text-base" />
          编辑推荐 · 每日更新精选书单
        </span>

        <h1 className="max-w-4xl font-heading text-4xl font-bold leading-tight text-foreground-50 md:text-6xl">
          人气漫画<span className="text-primary-400">编辑精选</span>
          <span className="mx-3 text-primary-500">·</span>
          口碑神作每日推荐
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-300 md:text-lg">
          香蕉漫画社编辑推荐专区，聚合站内人气作品与口碑漫画。每天精选值得追的好漫画，
          帮你免去翻遍全站找书的烦恼，一键直达追更入口。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#daily"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-lg bg-primary-500 px-7 py-3.5 text-base font-bold text-foreground-950 transition-colors hover:bg-primary-400 sm:w-auto"
          >
            <i className="ri-star-fill mr-2 text-lg" />
            查看今日精选
          </a>
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-lg border border-background-700 bg-background-900/60 px-7 py-3.5 text-base font-medium text-foreground-100 transition-colors hover:border-primary-500/50 hover:text-primary-300 sm:w-auto"
          >
            <i className="ri-fire-line mr-2 text-lg" />
            浏览人气榜单
          </a>
        </div>

        <div className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-xl border border-background-800 bg-background-800 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 bg-background-950/70 px-4 py-5">
              <span className="font-heading text-2xl font-bold text-primary-400">{s.value}</span>
              <span className="text-xs text-foreground-400">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#daily"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-2xl text-primary-400/80 transition-colors hover:text-primary-300"
      >
        <i className="ri-arrow-down-line animate-bounce" />
      </a>
    </section>
  );
}